import { render } from "./UsuarioDatosBasico.vue?vue&type=template&id=51aaee82"
import script from "./UsuarioDatosBasico.vue?vue&type=script&lang=js"
export * from "./UsuarioDatosBasico.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__